import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  margin-top: -50px;
  display: flex;
  justify-content: center;
  svg {
    width: 24px;
  }

  @media only screen and (max-width: 950px) {
    position: initial;
    margin-top: 26px;
    margin-bottom: 26px;
  }
`;

export const Card = styled.div`
  width: 100%;
  max-width: 980px;
  min-height: 200px;
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  padding: 24px 32px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  z-index: 10;

  .title-mobile {
    display: none;
  }
  .title-desktop {
    display: flex;
  }

  div.field {
    min-width: 300px;
  }

  @media only screen and (max-width: 950px) {
    ${props =>
      props.showFilter
        ? css`
            transition: 0.6s;
            min-height: 70px;
            height: 70px;
            overflow: hidden !important;
          `
        : css`
            height: 370px;
          `}

    margin: 0 16px;
    .title-desktop {
      display: none;
    }
    .title-mobile {
      display: flex;
      align-items: center;
      justify-content: space-between;

      svg {
        border-radius: 50%;
        cursor: pointer;
        transition: 0.6s;
        transform: ${props =>
          !props.showFilter ? 'rotate(-180deg)' : 'rotate(0deg)'};
      }
    }
    div.field {
      min-width: 100%;
      width: 100%;
    }
  }
`;

export const Title = styled.h2`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 23px;
  transition: 0.6s;
  color: ${props => (!props.showFilter ? '#475467' : '#98A2B3')};
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;

  h4 {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: #667085;
  }

  p {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #667085;
  }

  @media only screen and (max-width: 950px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;

    &.row-exp {
      display: none;
    }
  }
`;

export const RowSearch = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;

  h4 {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: #667085;
  }

  p {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #667085;
  }

  @media only screen and (max-width: 950px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;

    &.row-exp {
      display: none;
    }
  }
`;

export const SelectCustom = styled.div`
  .custom-select__control {
    border-radius: 3px;
    border: 2px solid #dadde2;
    background-color: #f9fafb;
    transition: border-color 0.3s ease-in-out;
  }

  .custom-select__control:hover,
  .custom-select__control--is-focused {
    border-color: #4a90e2;
    box-shadow: 0 0 5px rgba(74, 144, 226, 0.5);
  }

  .custom-select__menu {
    border-radius: 8px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  }

  .custom-select__option {
    padding: 10px;
    transition: background 0.3s;
  }

  .custom-select__option--is-selected {
    background-color: #4a90e2 !important;
    color: white;
  }

  .custom-select__option--is-focused {
    background-color: #e3f2fd !important;
  }
`;
